module.exports = "<span data-seek-time></span>\n<span data-duration></span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/seek_time/public/seek_time.html
// module id = 232
// module chunks = 0